import {decorate, observable} from 'mobx';
import {faArchive} from '@fortawesome/free-solid-svg-icons';
import {BaseModel} from './base';

export const PreparationState = {
  RUNNING: 'RUNNING',
  FINISHED: 'FINISHED',
  DONE: 'DONE',
};

export class Preparation extends BaseModel {
  static faIcon = faArchive;

  populateAttributesFromStore(rootStore) {
    this.storageUnit = rootStore.storageUnitStore.getById(this.storageUnitId);
    return super.populateAttributesFromStore(rootStore);
  }
}

decorate(Preparation, {
  id: observable,
  operationId: observable,
  storageUnitId: observable,
  storageUnit: observable,
  state: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
  deletedAt: observable,
  deletedBy: observable,
  expireDate: observable,
});
